<template>
    <div class="content-body">
        <div class="contents">
            <b-row>
                <b-col>
                    <h5>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</h5>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div class="content-inside">
                        <b-row>
                            <b-col>
                                <switches v-model="form.pointsExpiry" theme="custom" color="primary"
                                          type-bold="true" style="margin-top: 12px;"></switches>
                            </b-col>
                            <b-col align="right">
                                <img src="@/assets/images/achievement/action/edit.svg" alt="Edit Icon">
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col align="center">
                                <div class="inner">
                                    <p> </p>
                                </div>
                                <div style="margin-top: 30px">
                                    <strong>Lorom Ipsum</strong>
                                    <p>0 Points</p>
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                    </p>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
                <b-col>
                    <div class="content-inside">
                        <b-row>
                            <b-col>
                                <switches v-model="form.pointsExpiry" theme="custom" color="primary"
                                          type-bold="true" style="margin-top: 12px;"></switches>
                            </b-col>
                            <b-col align="right">
                                <img src="@/assets/images/achievement/action/edit.svg" alt="Edit Icon">
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col align="center">
                                <div class="inner">
                                    <p> </p>
                                </div>
                                <div style="margin-top: 30px">
                                    <strong>Lorom Ipsum</strong>
                                    <p>0 Points</p>
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                    </p>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
                <b-col>
                    <div class="content-inside">
                        <b-row>
                            <b-col>
                                <switches v-model="form.pointsExpiry" theme="custom" color="primary"
                                          type-bold="true" style="margin-top: 12px;"></switches>
                            </b-col>
                            <b-col align="right">
                                <img src="@/assets/images/achievement/action/edit.svg" alt="Edit Icon">
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col align="center">
                                <div class="inner">
                                    <p> </p>
                                </div>
                                <div style="margin-top: 30px">
                                    <strong>Lorom Ipsum</strong>
                                    <p>0 Points</p>
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                    </p>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
                <b-col>
                    <div class="content-inside">
                        <b-row>
                            <b-col>
                                <switches v-model="form.pointsExpiry" theme="custom" color="primary"
                                          type-bold="true" style="margin-top: 12px;"></switches>
                            </b-col>
                            <b-col align="right">
                                <img src="@/assets/images/achievement/action/edit.svg" alt="Edit Icon">
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col align="center">
                                <div class="inner">
                                    <p> </p>
                                </div>
                                <div style="margin-top: 30px">
                                    <strong>Lorom Ipsum</strong>
                                    <p>0 Points</p>
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                    </p>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
                <b-col cols="1">
                    <div class="content" style="vertical-align: middle">
                        <span class="align-middle">rob</span>
                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import Switches from "vue-switches";

export default {
    name: "membership",
    data() {
        return {
            msg: "Membership",
            form: {
                pointsExpiry: true
            }
        };
    },
    components: {
        Switches
    }
};
</script>

<style lang="scss" scoped>
.inner {
    background-color: transparent;
    width: 9em;
    height: 9em;
    border-radius: 4.5em;
    box-shadow: 0 0 8px #ccc, inset 0 0 8px #ccc;
    -webkit-animation: pulse 2s linear 1s infinite;
}
.inner p {
    display: block;
    text-align: center;
    line-height: 100px;
    font-family: sans-serif;
    font-size: 24px;
    color: #ccc;
    text-shadow: 0 0 4px #ccc;
}
</style>
